export enum MapType {
  google = 'google',
  yandex = 'yandex',
  baidu = 'baidu',
  mapbox = 'mapbox',
  auto = 'auto',
}
